<div class="image-upload-wrapper">
  <input
    #fileInputRef
    type="file"
    accept="image/png,image/jpeg,image/webp,image/gif,image/svg+xml"
    (change)="onFileSelected($event)"
    hidden
  />

  <div
    class="image-upload-trigger"
    [class.square]="square"
    [class.has-image]="previewUrl"
    [class.is-uploading]="isUploading"
    [class.disabled]="isDisabled"
    (click)="triggerFileInput()"
    [title]="isUploading ? uploadingLabel : uploadLabel"
  >
    <img
      *ngIf="previewUrl"
      [src]="previewUrl"
      class="image-preview"
      alt=""
    />
    <div *ngIf="!previewUrl && !isUploading" class="upload-placeholder">
      <nb-icon icon="cloud-upload-outline"></nb-icon>
      <span>{{ uploadLabel }}</span>
    </div>
    <div *ngIf="isUploading" class="upload-overlay">
      <nb-icon icon="loader-outline"></nb-icon>
    </div>
  </div>

  <button
    *ngIf="!previewUrl"
    nbButton
    ghost
    size="small"
    type="button"
    (click)="toggleUrlInput()"
    [nbTooltip]="'pages.chatStyling.form.logo.urlTooltip' | translate"
  >
    <nb-icon icon="link-2-outline"></nb-icon>
  </button>

  <button
    *ngIf="previewUrl"
    nbButton
    ghost
    size="small"
    status="danger"
    type="button"
    (click)="clear()"
  >
    <nb-icon icon="trash-2-outline"></nb-icon>
  </button>
</div>

<div class="url-input-row" *ngIf="showUrlInput">
  <input
    nbInput
    fullWidth
    size="small"
    type="url"
    [placeholder]="'pages.chatStyling.form.logo.urlPlaceholder' | translate"
    [(ngModel)]="urlInputValue"
    (keydown.enter)="saveUrl()"
    [status]="urlError ? 'danger' : 'basic'"
  />
  <button nbButton size="small" status="primary" (click)="saveUrl()">
    <nb-icon icon="checkmark-outline"></nb-icon>
  </button>
  <button nbButton size="small" ghost (click)="toggleUrlInput()">
    <nb-icon icon="close-outline"></nb-icon>
  </button>
  <span *ngIf="urlError" class="url-error">{{ urlError }}</span>
</div>
